module.exports = __webpack_public_path__ + "4a774cf76e696d72b2320cd551651a97.pdf";